import {
  LOADED,
  ADD_BOOK,
  REMOVE_BOOK,
  UPDATE_BOOK,
  EDIT_BOOK,
} from "./actionTypes";

export const loaded = (books) => {
  return {
    type: LOADED,
    payload: books,
  };
};
export const addBook = (book) => {
  return {
    type: ADD_BOOK,
    payload: book,
  };
};

export const editBook = (book) => {
  return {
    type: EDIT_BOOK,
    payload: book,
  };
};

export const updateBook = (book) => {
  return {
    type: UPDATE_BOOK,
    payload: book,
  };
};

export const removeBook = (bookId) => {
  return {
    type: REMOVE_BOOK,
    payload: bookId,
  };
};
